module.exports = __webpack_public_path__ + "static/flying_0-6ce55eca939c66cc375050a819f0cc7e.jpg";